import { Box, Card } from "@mui/material";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { getAllUserTemplates } from "../redux/entities/formBuilderEntity";
import TableListData from "../components/FormBuilder/subcomponents/TableListData";

const UserResponsePage = () => {
  const listData = useAppSelector(
    (state) => state.entities.formBuilder.getAllUserTemplates
    
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getAllUserTemplates());
  }, [dispatch]);

  return (
    <div className="d-flex mt-3 flex-column align-items-center justify-content-center">
      <h3>User Response List</h3>
      <div className="form-templates row mt-1"></div>
      <Box sx={{ width: "100%" }}>
        <Card sx={{ p: 2 }}>
          <TableListData data={listData} />
        </Card>
      </Box>
    </div>
  );
};

export default UserResponsePage;
